<app-log-header
  [activeTab]="activeTab()"
  [companiesList]="companiesList()"
  [selectedCompanyId]="selectedCompanyId()"
  (tabChanged)="switchTab($event)"
  (companyChanged)="selectCompany($event)" />

<app-f-chips />

<div
  class="table-container"
  saveHeight
  [bottomOffset]="64">
  <div class="table">
    <table
      mat-table
      [dataSource]="dataSource()"
      matSort
      (matSortChange)="sort.set($event)">
      @for (col of displayedColumns(); track col) {
        <ng-container [matColumnDef]="col">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef>
            {{ tableHeaderList[col] }}
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            @switch (col) {
              @case ('created_at') {
                {{ row[col] | customDateFormat: 'dd.MM.yyyy, HH:mm:ss' }}
              }
              @default {
                {{ row[col] || '-' }}
              }
            }
          </td>
        </ng-container>
      }

      <ng-container>
        <tr
          class="mat-row"
          *matNoDataRow>
          <td class="mat-cell">
            <div class="empty-block">
              <img
                class="empty-image"
                src="assets/images/empty-state.svg" />
              <h5 class="empty-text">No logs</h5>
            </div>
          </td>
        </tr>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns()"></tr>
      <tr
        mat-row
        class="horizontal-line"
        *matRowDef="let row; columns: displayedColumns()"></tr>
    </table>
  </div>
</div>

<mat-paginator
  (page)="pagination.set($event)"
  [length]="length()"
  [pageSize]="25"
  [showFirstLastButtons]="true"
  [pageSizeOptions]="[5, 10, 25]">
</mat-paginator>
